// Org-level gate for the Stealth Clock module.
//
// Enabled per-org via the main-admin panel toggle (org.stealthClockEnabled in DB,
// surfaced on billing/profile). Mirrors modules/employee-activity/orgGating.js exactly.
//
// This is a UI convenience ONLY — it decides whether to render/route, never whether
// access is allowed. Every endpoint re-checks the flag server-side.

/** Is the shift clock enabled at all for this org? Falls back to window.__orgProfile. */
export function isStealthClockEnabledForOrg(org) {
  const resolved = (org && typeof org === 'object')
    ? org
    : (typeof window !== 'undefined' ? window.__orgProfile : null);
  if (!resolved) return false;
  return resolved.stealthClockEnabled === true;
}

/**
 * Should this user see the org-admin shift timeline?
 * - Org must have stealthClockEnabled === true
 * - User must be an org admin (org_admin / main_admin)
 */
export function canUserAccessShiftTimeline(user, org) {
  if (!user) return false;
  if (!isStealthClockEnabledForOrg(org)) return false;
  return user.role === 'org_admin' || user.role === 'main_admin';
}
